var body = jQuery('body');
var lightbox = jQuery('.lightbox');
var backdrop = jQuery('.lightbox-backdrop');

// Open & close lightbox
jQuery(document).ready(function($) {
    $('.open-lightbox').click(function(event) {
        event.preventDefault();
        var target = $(this).data('lightbox');
        $('.lightbox-' + target).addClass('open');
        $('.backdrop-' + target).addClass('open');
        $('.close-' + target).show();
        body.addClass('overflow-hidden');
    });

    $('.close-lightbox').click(function(event) {
        event.preventDefault();
        lightbox.removeClass('open');
        backdrop.removeClass('open');
        body.removeClass('overflow-hidden');
        $(this).hide();
    });
});  

// Close lightbox
jQuery(document).on('keyup',function(evt) {
    if (evt.keyCode == 27) {
        lightbox.removeClass('open');
        backdrop.removeClass('open');
        body.removeClass('overflow-hidden');
        jQuery('.close-lightbox').hide();
    }
});
jQuery(document).mouseup(function(e) {
    if (!lightbox.is(e.target) && lightbox.has(e.target).length === 0) {
        lightbox.removeClass('open');
        backdrop.removeClass('open');
        body.removeClass('overflow-hidden');
        jQuery('.close-lightbox').hide(); 
    }
});